import React from 'react';
import PropTypes from 'prop-types';

const GridCell = React.memo(({ filled, preview, invalid, color, canPlace, clearPhase }) => {
  const getPreviewClass = () => {
    if (!preview) return '';
    if (canPlace === false) return 'preview invalid';
    if (canPlace === true) return 'preview valid';
    return 'preview'; // Default preview state when canPlace is undefined
  };

  const clearClass = clearPhase === 'highlight' ? 'cell-cleared'
    : clearPhase === 'disappear' ? 'cell-disappear'
    : '';

  return (
    <div 
      data-testid="grid-cell"
      className={`grid-cell ${filled ? 'filled' : ''} ${getPreviewClass()} ${clearClass}`.trim()}
      style={{
        backgroundColor: (filled && color ? color : undefined),
      }}
    ></div>
  );
});

GridCell.propTypes = {
  filled: PropTypes.bool.isRequired,
  preview: PropTypes.bool,
  invalid: PropTypes.bool,
  color: PropTypes.string,
  canPlace: PropTypes.bool,
  clearPhase: PropTypes.string
};

export default GridCell;
